import url from './url';
import request from './request';

import { LocalStorage } from '~/helpers';

export const getConversations = async ({
  order = -1,
  cursor = null,
  search = null,
  onlyUnread = false,
}) => {
  const params = new URLSearchParams({
    limit: 20,
    offset: 0,
    order: order === 1 ? 'asc' : 'desc',
    ...(cursor !== null && { cursor }),
    ...(search !== null && { search }),
    onlyUnread,
  });

  return request(`${url.conversations}?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
};

export const getConversationByID = async (conversationID) =>
  request(`${url.conversations}/${conversationID}`, {
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
